module.exports = __webpack_public_path__ + "images/0406b6e8.jpg";